import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Flex, rem, StyleProps, Text } from '@bonusly/design-system';

import { UserAvatar } from '../user/user-avatar';

interface PendingMessageProps extends StyleProps {
	userId: string;
}

export const PendingMessage: FC<PendingMessageProps> = ({ userId, ...rest }) => {
	const { t } = useTranslation('feedback');

	return (
		<Flex alignItems="center" columnGap={4} {...rest}>
			<Box flexBasis={rem(40)}>
				<UserAvatar userId={userId} />
			</Box>

			<Text color="text.softest">{t('request.pending')}</Text>
		</Flex>
	);
};
